// Source de vérité unique pour les couleurs et métadonnées de postes.
// Consommé par PlayerManagement, PlayerProfile, PlayerCard (à migrer).
export const POSITION_COLORS = {
  'Gardien':   { abbr: 'GB',  label: 'GARDIENS',   color: '#4F8EF7', bg: 'rgba(79,142,247,0.12)'  },
  'Défenseur': { abbr: 'DEF', label: 'DÉFENSEURS', color: '#3a7bd5', bg: 'rgba(58,123,213,0.12)'  },
  'Milieu':    { abbr: 'MIL', label: 'MILIEUX',    color: '#8b5fbf', bg: 'rgba(139,95,191,0.12)'  },
  'Attaquant': { abbr: 'ATT', label: 'ATTAQUANTS', color: '#d5473a', bg: 'rgba(213,71,58,0.12)'   },
}
